<p-card header="{{title | titlecase}}" subheader="{{subTitle}}" styleClass="ui-card-shadow">
  <p-table [value]="datasource" [loading]="loading" [lazy]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>Loan #</th>
        <th>Completed Date</th>
        <th>Task Name</th>
        <th>Partnership</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-source>
      <tr>
        <td><a href="{{getPropertyViewUri(source.PropertyId)}}" (mouseover)="displayAddress(op, $event, source)" (mouseout)="op.hide($event)">{{source.LoanNumber}}</a>
          <a class="iconNewWindow hiddenspace" target="_blank" href="{{getPropertyViewUri(source.PropertyId)}}"></a></td>
        <td>{{source?.CloseDate | dateTimeFormat:'MM/dd/yyyy'}}</td>
        <td><a href="{{getTaskViewUri(source.EventLocation,source.PropertyId, source.TaskInstanceId, source.ParentEventTrackingId)}}" target="_self" title="{{source.EventName}}">{{source.EventName | slice:0:15}}<span *ngIf="source.EventName.length > 15">...</span></a></td>
        <td>{{source.LenderPublicName}}</td>
      </tr>
    </ng-template>
  </p-table>
  <p-overlayPanel #op [dismissable]="true" appendTo="body">
    <div *ngIf="sourceSelected">
        {{sourceSelected.LoanNumber}} - 
        {{sourceSelected.Address.Address1}}<span *ngIf="sourceSelected.Address.Address2">,{{sourceSelected.Address.Address2}}</span>, {{sourceSelected.Address.City}},
        {{sourceSelected.Address.State}}, {{sourceSelected.Address.PostalCode}}
    </div>
  </p-overlayPanel>
</p-card>